// @ts-nocheck
import {
    BANNERS_ORDER_DRAWER_CHANGED,
    PROMOTION_BANNER_ITEM_CHANGED,
    PROMOTION_BANNER_LIST_RECEIVED,
} from '../../types';

const initialState = {
    list: [],
    current: null,
    bannersOrderDrawer: {
        isVisible: false,
        bannersList: [],
    },
};

const promotionBanner = (state = initialState, action) => {
    const { payload } = action;

    switch (action.type) {
        case PROMOTION_BANNER_LIST_RECEIVED: {
            return {
                ...state,
                list: payload,
            };
        }
        case PROMOTION_BANNER_ITEM_CHANGED: {
            return {
                ...state,
                current: payload,
            };
        }
        case BANNERS_ORDER_DRAWER_CHANGED: {
            return {
                ...state,
                bannersOrderDrawer: {
                    ...state.bannersOrderDrawer,
                    ...payload,
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default promotionBanner;
